module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/mail_mv_bg-706ebd6e44a1ad59ec24a7b3fa23c537.png";